export default class DateUtils {
  static isEmpty(str: string) {
    try {
      return !(str && str.trim().length);
    } catch (e) {
      return false;
    }
  }

  static isEmptyObject(obj) {
    if (!obj) return true;
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
}

/**
 * @description Method to get date month year
 * @params Date string
 * @return {string} -'YYYY-MM-DD'
 */
export function getDateMonthYear(date) {
  date = new Date(date);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
}

/**
 * @description Method to get today's Date
 * @params Timezone
 * @return {string}
 */

export function getTodayDate(clientTimeZone: string) {
  return new Date().toLocaleString("en-US", {
    timeZone: clientTimeZone,
  });
}

/**
 * @description Method to get Date and time
 * @params date & type
 * @return {string} Based on type either 'DD-MM-YYYY HH:MM:SS'
 * or 'YYYY-MM-DD HH:MM:SS'
 */
export function calculateDateTime(date, type: string = null) {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  return type == "metaDownload"
    ? `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
    : `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * @description Method to get Date and time
 * @params date & type
 * @return {string} Based on type either 'DD-MM-YYYY HH:MM:SS'
 * or 'YYYY-MM-DD HH:MM:SS'
 */
export function getDateTime(
  type:
    | "metaDownload"
    | "liFlights"
    | "liPayLoad"
    | "ioFlights" = "metaDownload",
  clientTimeZone: string = null,
  date = null
) {
  if (type == "liFlights" || type == "ioFlights") {
    let today_client_tz = getTodayDate(clientTimeZone);
    date = new Date(today_client_tz);
    date = new Date(date.setHours(date.getHours() + 1));
  } else if (type == "liPayLoad") {
    date = date;
  } else {
    date = new Date();
  }
  return calculateDateTime(date, type);
}

/**
 * @description Method to get dateobject from string
 * @params date of string type
 * @return {Date}
 */
export function getDateObjectfromString(dateString) {
  dateString = dateString.replace(" ", "T");
  return new Date(dateString);
}

/**
 * @description Method to check if two date intervals exceeds a limit
 * @params  start date, end date, interval limit: number
 * @return {Boolean}
 */

export function isDateRangeLongerThanLimit(
  start_date,
  end_date,
  limit: number
) {
  if (start_date && end_date) {
    let startDate, endDate;
    startDate = new Date(JSON.parse(JSON.stringify(start_date)));
    endDate = new Date(JSON.parse(JSON.stringify(end_date)));
    const diffTime = Math.abs(startDate - endDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays > limit;
  }
  return false;
}

export function getNowInTimezone(timezone: string): number {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const parts = formatter.formatToParts(new Date());

  const year = parts.find((p) => p.type === "year")?.value;
  const month = parts.find((p) => p.type === "month")?.value;
  const day = parts.find((p) => p.type === "day")?.value;
  const hour = parts.find((p) => p.type === "hour")?.value;
  const minute = parts.find((p) => p.type === "minute")?.value;
  const second = parts.find((p) => p.type === "second")?.value;

  return new Date(
    `${year}-${month}-${day}T${hour}:${minute}:${second}`
  ).getTime();
}



/**
 * @description Get 'YYYY-MM-DD' for a date in the given timezone
 */
export function getDateInTimezone(date: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const get = (t: string) => parts.find((p) => p.type === t)?.value;
  return `${get("year")}-${get("month")}-${get("day")}`;
}

export function isCreatedToday(createdAt: string, clientTimeZone: string): boolean {
  if (!createdAt || !clientTimeZone) return false;

  const createdUtc = new Date(
    createdAt.trim().replace(/\s*UTC$/i, "").replace(" ", "T") + "Z"
  );
  if (isNaN(createdUtc.getTime())) return false;

  const createdDate = getDateInTimezone(createdUtc, clientTimeZone);
  const todayDate = getDateInTimezone(new Date(), clientTimeZone);

  return createdDate === todayDate;
}